import { get } from 'axios'

export default {
    actions: {
        async getObjectGroups(ctx, params = {}) {
            if (ctx.state.objectGroups.length) return Promise.resolve(ctx.state.objectGroups)
            console.time('Load object groups time')

            const request = await get(
                '/api/Global/RolesObjectGroups',
                {
                    headers: params.headers,
                    params: params
                }
            )

            const label = `[vuex] [global] Get object groups [${request.data.Data.length}]`;
            console.groupCollapsed(label);
            console.info(request.data.Data);
            console.timeEnd('Load object groups time')
            console.groupEnd(label);

            return ctx.commit('updateObjectGroups', request.data.Data)
        }
    },
    mutations: {
        updateObjectGroups(state, objectGroups) {
            state.objectGroups = objectGroups
        },
    },
    state: {
        objectGroups: [],
    },
    getters: {
        myObjectGroups(state) {
            return state.objectGroups
        },
        resolveObjectGroup(state) {
            return ({ ObjectGroupID, object_group_id }) => {
                return state.objectGroups.find(o => o.ObjectGroupID == (object_group_id || ObjectGroupID))
            }
        },
        getObjectGroupByID(state) {
            return (objectGroupID) => {
                return state.objectGroups.find(o => o.ObjectGroupID === objectGroupID)
            }
        },
        getObjectGroupByIDs(state) {
            return (objectGroupIDs) => {
                const indexes = objectGroupIDs ?? []
                return state.objectGroups.filter(o => indexes.includes(o.ObjectGroupID))
            }
        },
    },
}